// @ts-check
import adyenApplePayStrategy from '../../methods/applepay/strategies/AdyenApplePayStrategy';
import stripeApplePayStrategy from '../../methods/applepay/strategies/StripeApplePayStrategy';
import applePayMethod from '../../methods/applepay/ApplePay';

const engines = {
  adyen: adyenApplePayStrategy,
  stripe: stripeApplePayStrategy,
};

/**
 * Factory function for creating Apple Pay instances.
 */
function ApplePayFactory() {
  let strategy;

  /**
   * Creates an instance of Apple Pay payment with the given engine.
   */
  function create({ engine }) {
    strategy = engines[engine];

    if (!strategy) {
      throw new Error(`Apple Pay engine '${engine}' not found`);
    }

    applePayMethod.setStrategy(strategy);
    return applePayMethod;
  }

  return { create };
}

const applePayFactory = ApplePayFactory();

export default applePayFactory;
